import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"14\" cy=\"14\" r=\"14\" fill=\"#c0e2ad\" fill-opacity=\".3\"></circle><circle cx=\"14\" cy=\"14\" r=\"13.5\" stroke=\"#c0e2ad\" stroke-opacity=\".5\"></circle><path fill=\"#000\" d=\"m13.858 23-3.168-2.4h6.335z\"></path><rect width=\"13.714\" height=\"13.714\" x=\"7\" y=\"7\" fill=\"#000\" rx=\"2\"></rect><path fill=\"#fff\" d=\"M14.693 11.5v5.7h-1.125v-4.402l-1.352.43v-.887l2.356-.84z\"></path>", 5)
  ]))]))
}
export default { render: render }